
import Badge from 'vux/src/components/badge/index.vue'




export default {
props:{
item:{
type:Object,
}
},
name: "capitalitem",
components:{Badge},
data(){
return{
helpstatearr: [],

path: '/zcrecdetail/' + this.item.afq005+'/'+this.item.acr001,
}
},
methods:{
gocart(item){
this.L("myIndex",0)
this.L("typeIndex",1)
this.$router.push('/zccertificate/'+item.title+'/'+item.afq065+'/'+item.acr001+'/'+this.G("zcuserid")+'/null/'+encodeURIComponent(this.G("zcnickname"))+'/'+this.item.afq007+'/'+encodeURIComponent(this.item.acr036))
},
payhelp(item){
if(this.isWeixinCient()){
console.log('这是微信的我要支持')
this.L("typeIndex",1)
this.L("myIndex",0)
this.$router.push('/zchelphe/'+item.acr001+'/'+item.planMoney+'/'+item.title+'/'+this.G("zcuserid")+'/null/'+encodeURIComponent(this.G("zcnickname"))+'/null/null/null/'+encodeURIComponent(this.item.acr036));
}else{
this.showToast('','text','请在微信内打开','20em','','')
}
},
goQKL(data){
window.location.href=this.QKL_URL+data
},



























}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/zcitem.vue